export default __webpack_public_path__ + "static/media/Category-V-Vinyl.b27d873a.jpg";